import { render, staticRenderFns } from "./PopupBookingPoliciesWarning.vue?vue&type=template&id=c405d638&scoped=true&"
import script from "./PopupBookingPoliciesWarning.vue?vue&type=script&lang=js&"
export * from "./PopupBookingPoliciesWarning.vue?vue&type=script&lang=js&"
import style0 from "./PopupBookingPoliciesWarning.vue?vue&type=style&index=0&id=c405d638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405d638",
  null
  
)

export default component.exports